export default {
    download: 'Click to download',
    Copyright: 'Copyright',
    updateDate: "Update date",
    company: "XGrids",
    app: 'LixelGO',
    version: "1.1.5",
    updateTime: "2024.11.26",
    apk: 'https://cdn-bukbv1.xgrids.cloud/prd/lixel/app/LixelGo_android/LG_i18n_115_20241126.apk',
    tip: "Please use your phone's default browser to open this.",
    tip1:'LCC Scan',
}